'use strict';
var parent = require('../../actual/symbol/to-primitive');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/symbol/to-primitive.js
// module id = 642
// module chunks = 13